var map = {
	"./Arrow Up.svg": "dac5",
	"./Clip.svg": "2b1c",
	"./Duplicate.svg": "a7f9",
	"./GIF.svg": "6d71",
	"./Go-Back.svg": "0b48",
	"./Go-Forward-sm.svg": "346b",
	"./Go-Forward.svg": "a0de",
	"./Group 2.svg": "1b62",
	"./Group 4.svg": "c436",
	"./Group 47.png": "3f2a",
	"./Group 5.svg": "9ca8",
	"./Search.svg": "b8b8",
	"./Selector Bubble.svg": "e83b",
	"./Selector.svg": "40da",
	"./Send-Button.svg": "3c41",
	"./Send.svg": "966b",
	"./add-icon-gray.svg": "93c4",
	"./add-page.svg": "9237",
	"./arrow-left.svg": "c633",
	"./arrow-right.svg": "2a29",
	"./arrow-up.svg": "3cdf",
	"./autoplay-sm.svg": "8a1e",
	"./autoplay.svg": "1cb5",
	"./award-winner.svg": "fe2f",
	"./bell.svg": "3cc2",
	"./bg-pattern.png": "64d3",
	"./bg-pattern2.png": "c8e3",
	"./bg-pattern3.png": "2c3a",
	"./blue-search.svg": "0a7d",
	"./check-box-large.svg": "dd8c",
	"./check-box.svg": "84c2",
	"./check-circle.svg": "ac80",
	"./check-icon.png": "ee51",
	"./check-icon.svg": "ded5",
	"./check-white.svg": "98a8",
	"./checkbox-lg.svg": "ff82",
	"./chevron-left.svg": "7328",
	"./close-gray.svg": "7b61",
	"./close-with-circle.svg": "dd4f",
	"./close.png": "f096",
	"./cloud-upload.svg": "b2c8",
	"./comment.svg": "5a79",
	"./dot-toggle.svg": "abf5",
	"./down-angle.svg": "cf9e",
	"./edit.svg": "f232",
	"./emoji/crying.png": "e408",
	"./emoji/crying.svg": "a442",
	"./emoji/heart.svg": "4942",
	"./emoji/laughing.svg": "6b4e",
	"./emoji/love.svg": "efe0",
	"./emoji/pop-up-Emoji.svg": "9679",
	"./emoji/wow.svg": "6cc7",
	"./empty-check-circle.svg": "6f02",
	"./episode.svg": "7c80",
	"./eye.svg": "ff6e",
	"./facebook-sm.svg": "0967",
	"./facebook.svg": "1c90",
	"./go-back-sm.svg": "9f71",
	"./green-check.svg": "8339",
	"./group-10.svg": "f46f",
	"./group-icon.svg": "abc3",
	"./hamburger.svg": "83ed",
	"./heart-fill.svg": "97d3",
	"./heart-icon.svg": "faec",
	"./heart.svg": "ea3d",
	"./image-icon.svg": "a6af",
	"./image.svg": "6c73",
	"./instagram-lg.svg": "f37d",
	"./instagram-sm.svg": "8ed8",
	"./instagram.svg": "3999",
	"./left-angle-lg.svg": "4bbc",
	"./mbl-search.png": "34d2",
	"./menu.svg": "b778",
	"./message-circle.svg": "980f",
	"./message-square.svg": "8bc0",
	"./messanger.svg": "5a49",
	"./minus-icon.svg": "1b49",
	"./more-horizontal.svg": "4aa4",
	"./more-vertical.svg": "7764",
	"./move.svg": "e79c",
	"./next-arrow.png": "7662",
	"./onboarding-shape-lg.svg": "ff11",
	"./onboarding-shape-sm.svg": "a188",
	"./oval.svg": "2431",
	"./oval2.svg": "524d",
	"./paperclip.png": "a3e0",
	"./path-28.png": "ce5c",
	"./path-28.svg": "ef53",
	"./path-29.png": "2db6",
	"./plus-icon.svg": "3d1d",
	"./plus-white.svg": "0572",
	"./repeat.svg": "5c15",
	"./search-icon-bld.svg": "89a1",
	"./search-icon.svg": "1ae5",
	"./search-sm.svg": "07fc",
	"./settings.svg": "1f0e",
	"./share-2 (2).svg": "19c7",
	"./share-icon.svg": "8eba",
	"./smaller-send-arrow.svg": "10b3",
	"./snapchat-sm.svg": "38f7",
	"./snapchat.svg": "854d",
	"./social-share.svg": "56fe",
	"./sort-down.png": "ac62",
	"./sort-down.svg": "db24",
	"./sort-up.svg": "a3e6",
	"./swipe-down.svg": "669f",
	"./swipe-up.svg": "4783",
	"./toggle-down.png": "a6c2",
	"./toggle-up.png": "a30e",
	"./trash-2.svg": "3dd1",
	"./twitter-lg.svg": "15f2",
	"./twitter-sm.svg": "f2eb",
	"./twitter.svg": "ee44",
	"./undraw_not_found.svg": "10de",
	"./upload-camera.svg": "f143",
	"./upload.svg": "93a9",
	"./varified-icon.svg": "8cc4",
	"./zoom-box.svg": "cfe8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";